import React from 'react';

import Element from '~/src/components/element/Element';

const List = ({listType, listItems}) => {
    const Tag = listType === 'ordered' ? 'ol' : 'ul';

    return (
        <Tag>
            {listItems.map((item, index) => {
                return (
                    <li key={index}>
                        <Element {...item} />
                    </li>
                );
            })}
        </Tag>
    );
};

export default List;
